import { FC, useContext, useState } from 'react';

import { Input, SearchIcon } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { ClubCard } from './ClubCard';
import s from './ClubList.module.scss';
import { IClubsProps } from './interfaces';

export const ClubList: FC<IClubsProps> = ({
  clubs,
  currentClubId,
  selectedClubId,
  setSelectedClubId,
  isCopySetting,
}) => {
  const { t } = useContext(LocalizationContext);

  const [searchStr, setSearchStr] = useState('');

  return (
    <div
      className={s.container}
      onClick={(e) => e.stopPropagation()}
      data-testid="clubs-list"
    >
      <Input
        dataTestId="search"
        value={searchStr}
        onChange={setSearchStr}
        placeholder={t('clubs.search.placeholder')}
        leftContent={<SearchIcon color="primary" />}
        bordered
        variant="secondary"
      />
      <div className={s.clubs} data-testid="list">
        {clubs
          .filter(
            (club) =>
              (club.name.toLowerCase().includes(searchStr.toLowerCase()) ||
                club.address.toLowerCase().includes(searchStr.toLowerCase()) ||
                club.id.toString().includes(searchStr)) &&
              club.id !== currentClubId
          )
          .map((club) => (
            <ClubCard
              key={`club-${club.id}`}
              club={club}
              selectClub={() => setSelectedClubId(club.id)}
              selected={club.id === selectedClubId}
              isCopySetting={isCopySetting}
            />
          ))}
      </div>
    </div>
  );
};
